import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const HorizontalBarChartIcon = () => (
  <IconContainer>
    <svg version="1.1" id="Layer_1" x="0px" y="0px" width="68px" height="66px" viewBox="0 0 68 66" enableBackground="new 0 0 68 66" >  
      <image id="image0" width="68" height="66" x="0" y="0"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABCCAAAAADLIS9zAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZ
      cwAAAGAAAABgAPBrQs8AAAAHdElNRQflBhYQOQRloDehAAABQ0lEQVRYw+3Wv0vDQBTA8W/SJ4qg
      IP5YundrRQQRi2sXJ6f+C27+JW5OTq4ODi5CBweRLm6dBNGCKYoN6igIUl1cegmXe70OB+a2vHf5
      3A8uLxcdDchr1cMZnFucb/CcuhsINNcy0bTLSIc0apnofVdBQKzqXSL/FRE4m81Ev9TIR25iToO0
      k9x4dVWBRD9T2JPpbOzxQP/SwsHKOPI4wcjvDwYC28s64ruDsZECGzUd8tkxI+Ec+xIJGRE415QO
      yPnBCmh+3X/NuDHIfqI3FhvjzwEVpROX5VRaTSty5zTWrR2BzcKi1Bvad05gq7AopUN7PpxjXyIh
      IwIX80WdXouRF7exbNk9l6843rWmAypKpxPUWGMxden5T+RGYH3Ji0j6I4Ed5U3JaFf9gI59iYSM
      CFxeewlvIPDkO5GKtLyNqP4LvBs5CCwVIFAAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDYtMjJU
      MTY6NTc6MDQrMDA6MDCP2hEGAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTA2LTIyVDE2OjU3OjA0
      KzAwOjAw/oepugAAAABJRU5ErkJggg==" />
    </svg>
  </IconContainer>
)

export default HorizontalBarChartIcon